import { post } from "../../../../api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const computeFolderNextStatesList = (documentId, siteId) =>
  post(`${url}/leasingfolders/${documentId}/${siteId}/states/compute`, { documentId, siteId });
const updateFolderState = (documentId, siteId, stateId, facilityId) =>
  post(`${url}/leasingfolders/${documentId}/${siteId}/state`, { documentId, siteId, stateId, facilityId });

const exp = {
  computeFolderNextStatesList,
  updateFolderState
};
export default exp;
